var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIiko({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.603125, 0, -0.271411, -2.315093, 254.787342, 559.0243)",
    style: {}
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.906154, 0, 0, -0.988677, 235.514587, 468.114471)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(0.046877, 0, 0, 0.047748, 65.241318, 224.993027)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(100, 109, 124)"
    },
    d: "M 115.215 131.092 C 115.215 131.092 161.83881337199023 163.08735373443994 163.175 182.232 C 164.67938661852904 203.78658605455263 126.79992312938157 252.53524192883302 111.975 254.874 C 103.50045602366946 256.21093159493154 90.01492250429774 245.7243492538783 88.749 237.44 C 86.80156854811229 224.6957741562747 125.43530083762293 200.62501321983595 128.884 181.65 C 131.89456178495803 165.08565298709988 115.215 131.092 115.215 131.092 C 115.215 131.092 115.21500000000002 131.092 115.215 131.092",
    transform: "matrix(-0.993877, -0.050906, 0.038512, -1.004188, 243.690752, 393.302055)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(100, 109, 124)"
    },
    d: "M 113.081 215.278 C 113.081 215.278 160.08853884645123 247.99303402680044 161.044 267.288 C 162.13660530657097 289.35251003698295 120.92007919873352 338.98434332956657 105.35 341.164 C 96.56884785434745 342.3932742126783 82.99149315936975 331.77325007175386 81.864 323.434 C 80.10570472140515 310.4291636457087 121.34422408765765 286.15923457478794 125.48 266.696 C 129.03550113886138 249.9635768312141 113.081 215.278 113.081 215.278 C 113.08099999999999 215.27799999999996 113.08099999999999 215.27799999999996 113.081 215.278"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.603125, 0, -0.271411, -2.315093, 261.207829, 559.137704)",
    style: {}
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.906154, 0, 0, -0.988677, 235.514587, 468.114471)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(0.046877, 0, 0, 0.047748, 65.241318, 224.993027)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(100, 109, 124)"
    },
    d: "M 115.215 131.092 C 115.215 131.092 161.83881337199023 163.08735373443994 163.175 182.232 C 164.67938661852904 203.78658605455263 126.79992312938157 252.53524192883302 111.975 254.874 C 103.50045602366946 256.21093159493154 90.01492250429774 245.7243492538783 88.749 237.44 C 86.80156854811229 224.6957741562747 125.43530083762293 200.62501321983595 128.884 181.65 C 131.89456178495803 165.08565298709988 115.215 131.092 115.215 131.092 C 115.215 131.092 115.21500000000002 131.092 115.215 131.092",
    transform: "matrix(-0.993877, -0.050906, 0.038512, -1.004188, 243.690752, 393.302055)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(100, 109, 124)"
    },
    d: "M 113.081 215.278 C 113.081 215.278 160.08853884645123 247.99303402680044 161.044 267.288 C 162.13660530657097 289.35251003698295 120.92007919873352 338.98434332956657 105.35 341.164 C 96.56884785434745 342.3932742126783 82.99149315936975 331.77325007175386 81.864 323.434 C 80.10570472140515 310.4291636457087 121.34422408765765 286.15923457478794 125.48 266.696 C 129.03550113886138 249.9635768312141 113.081 215.278 113.081 215.278 C 113.08099999999999 215.27799999999996 113.08099999999999 215.27799999999996 113.081 215.278"
  }))))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.603125, 0, -0.271411, -2.315093, 267.679173, 559.305794)",
    style: {}
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.906154, 0, 0, -0.988677, 235.514587, 468.114471)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.046877, 0, 0, 0.047748, 65.241318, 224.993027)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(100, 109, 124)"
    },
    d: "M 115.215 131.092 C 115.215 131.092 161.83881337199023 163.08735373443994 163.175 182.232 C 164.67938661852904 203.78658605455263 126.79992312938157 252.53524192883302 111.975 254.874 C 103.50045602366946 256.21093159493154 90.01492250429774 245.7243492538783 88.749 237.44 C 86.80156854811229 224.6957741562747 125.43530083762293 200.62501321983595 128.884 181.65 C 131.89456178495803 165.08565298709988 115.215 131.092 115.215 131.092 C 115.215 131.092 115.21500000000002 131.092 115.215 131.092",
    transform: "matrix(-0.993877, -0.050906, 0.038512, -1.004188, 243.690752, 393.302055)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "rgb(0, 0, 0)",
      fill: "rgb(100, 109, 124)"
    },
    d: "M 113.081 215.278 C 113.081 215.278 160.08853884645123 247.99303402680044 161.044 267.288 C 162.13660530657097 289.35251003698295 120.92007919873352 338.98434332956657 105.35 341.164 C 96.56884785434745 342.3932742126783 82.99149315936975 331.77325007175386 81.864 323.434 C 80.10570472140515 310.4291636457087 121.34422408765765 286.15923457478794 125.48 266.696 C 129.03550113886138 249.9635768312141 113.081 215.278 113.081 215.278 C 113.08099999999999 215.27799999999996 113.08099999999999 215.27799999999996 113.081 215.278"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIiko);
export default __webpack_public_path__ + "static/media/iiko.a6d9ea9f9ae72c8e9ddee250395c2c38.svg";
export { ForwardRef as ReactComponent };